import { EOrderIndicate, EOrderType } from '@webtrader/core/api/order';
import { ETradeFillPolicy } from '@webtrader/core/api/trade';
import request from '@webtrader/core/request';

export type TMarketTradeOrderType = EOrderType.BUY | EOrderType.SELL;

export interface ICreateMarketTradeParams {
  orderType: TMarketTradeOrderType;
  symbol: string;
  lotSize: number;
  indicate?: EOrderIndicate;
  stopLoss?: number;
  takeProfit?: number;
  fillPolicy?: ETradeFillPolicy;
  units?: string;
}

export interface IUpdateMarketTradeParams
  extends Pick<ICreateMarketTradeParams, 'symbol' | 'indicate' | 'stopLoss' | 'takeProfit' | 'units' | 'fillPolicy'> {
  orderId: string;
}

export default {
  create: (params: ICreateMarketTradeParams) => request.post<boolean>('/api/trade/v2/market', params),
  update: (params: IUpdateMarketTradeParams) => request.patch<boolean>('/api/trade/v2/market', params)
};
